module.exports = __webpack_public_path__ + "img/list_grey.724ed9c5.svg";